"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Title = _antd.Typography.Title,
  Paragraph = _antd.Typography.Paragraph,
  Text = _antd.Typography.Text,
  Link = _antd.Typography.Link;
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.Typography, null, /*#__PURE__*/_react.default.createElement(Title, {
    level: 4
  }, "\u300A\u6545\u4E61\u300B "), /*#__PURE__*/_react.default.createElement(Paragraph, null, "\u2014\u2014\u9C81\u8FC5"), /*#__PURE__*/_react.default.createElement(Paragraph, null, /*#__PURE__*/_react.default.createElement(Text, {
    strong: true
  }, "\u6DF1\u84DD\u7684\u5929\u7A7A\u4E2D\u6302\u7740\u4E00\u8F6E\u91D1\u9EC4\u7684\u5706\u6708"), "\uFF0C\u4E0B\u9762\u662F\u6D77\u8FB9\u7684\u6C99\u5730\uFF0C\u90FD\u79CD\u7740\u4E00\u671B\u65E0\u9645\u7684\u78A7\u7EFF\u7684\u897F\u74DC\uFF0C\u5176\u95F4\u6709\u4E00\u4E2A\u5341\u4E00\u4E8C\u5C81\u7684\u5C11\u5E74\uFF0C\u9879\u5E26\u94F6\u5708\uFF0C\u624B\u634F\u4E00\u67C4\u94A2\u53C9\uFF0C", /*#__PURE__*/_react.default.createElement(Text, {
    mark: true
  }, "\u5411\u4E00\u5339\u7339\u5C3D\u529B\u7684\u523A\u53BB"), "\uFF0C\u90A3\u7339\u5374\u5C06\u8EAB\u4E00\u626D\uFF0C\u53CD\u4ECE\u4ED6\u7684\u80EF\u4E0B\u9003\u8D70\u4E86\u3002"), /*#__PURE__*/_react.default.createElement(Paragraph, null, /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(Link, {
    href: "#"
  }, "\u72C2\u4EBA\u65E5\u8BB0")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(Link, {
    href: "#"
  }, "\u5450\u558A")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(Link, {
    href: "#"
  }, "\u5F77\u5FA8")))));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorSuccess'],
  key: 'default'
};
var _default = exports.default = componentDemo;